import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import UserForm from '../components/user/UserForm';
import UserTable from '../components/user/UserTable';

const UserPage = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  const handleEdit = (user) => {
    setSelectedUser(user);
  };

  const handleFormReset = () => {
    setSelectedUser(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' }, 
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <UserTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <UserForm
          selectedUser={selectedUser}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default UserPage;
